import { Card, CardContent, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

import styles from './infoCard.module.scss';

interface IBaseProps {
  children?: ReactNode;
}

interface ICompoundInfoCard {
  Title: React.FC<IBaseProps & { action?: ReactNode }>;
  Subtitle: React.FC<IBaseProps>;
  Content: React.FC<IBaseProps>;
}

const InfoCard: FC<IBaseProps> & ICompoundInfoCard = ({ children }) => {
  return (
    <Card variant="outlined" className={styles['info-card']}>
      <CardContent className={styles['info-card-content-container']}>{children}</CardContent>
    </Card>
  );
};

InfoCard.Title = ({ children, action }) => {
  return (
    <div className={styles['info-card-title-container']}>
      <p className={styles['info-card-title']}>{children}</p>
      {action}
    </div>
  );
};
InfoCard.Subtitle = ({ children }) => {
  return (
    <Typography variant="caption" color="primary" display="block" mb={1}>
      {children}
    </Typography>
  );
};

InfoCard.Content = ({ children }) => {
  return <section className={styles['info-card-content']}>{children}</section>;
};

export default InfoCard;
